import { schema } from "normalizr";
import ImageSchema from "./image";
const deviceSchema = new schema.Entity(
    "devices",
    { iconImage: ImageSchema },
    { idAttribute: "id" }
);

export default deviceSchema;



// WEBPACK FOOTER //
// ./src/schemas/device.js